import Footer from "../../components/common/layout/Footer";
import { Breadcrumbs, CloudServices, IntroSection, OtherServices, CloudCoreServices } from "@/components/features/cloudSolutions";
import SEO from "@/components/common/seo/seo";
import CallToAction from "@/components/common/sections/CallToAction";

export default function AiSolutions() {
    return(
        <div>
            {/* SEO for Home Page */}
            <SEO
                title="Cloud Solutions - SAN micron"
                description="Empower Your Business with Cutting-Edge Cloud Solutions Revolutionize Your Operations with SAN micron Discover how our innovative cloud solutions can transform your business, enhancing efficiency and scalability."
            />

            <Breadcrumbs />
            <IntroSection />
            <OtherServices />
            <CloudCoreServices />
            {/* <CloudSolutions /> */}
            <CallToAction 
                title="Unlock the Future of Cloud Technology Today"
            />
            <CloudServices />
            <Footer />
        </div>
    );
}